export enum FreeTextAttributeType {
  HOUSEHOLD_MEASUREMENT = "HouseholdMeasurement",
  MEASUREMENT_AMT_PREPARED = "MeasurementAmtPrepared",
  SERVINGS_PER_CONTAINER = "ServingsPerContainer",
  PORTIONS_PER_CONTAINER = "PortionsPerContainer",
  CAUTIONARY_MESSAGES = "CautionaryMessages",
  ALLERGY_ADVICE = "AllergyAdvice",
  QUANTITATIVE_DECLARATION_OF_INGREDIENTS = "QuantitativeDeclarationOfIngredients",
  NET_QUANTITY = "NetQuantity",
  MANUFACTURER_NAME_AND_ADDRESS = "ManufacturerNameAndAddress",
  COUNTRY_OF_ORIGIN = "CountryOfOrigin",
  PREPARATION_INSTRUCTIONS = "PreparationInstructions",
  STORAGE_INSTRUCTIONS = "StorageInstructions",
  FOOD_ADDITIVES = "FoodAdditives",
  DURABILITY_INDICATION = "DurabilityIndication",
  ALCOHOLIC_STRENGTH_BY_VOLUME = "AlcoholicStrengthByVolume",
}